import styled from 'styled-components';
import { Flex, Box } from 'component/base/Grid';
import BaseLink from 'component/base/Link';

export const Container = styled(Flex)`
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.white};

  & > * {
    margin-bottom: 32px;
  }
`;

Container.defaultProps = {
  alignItems: 'center',
  flexDirection: 'column',
  pt: 132,
};

export const Footer = styled(Box)`
  ${(props) => props.theme.text.BodySecondary};
  font-size: 14px;
  text-align: center;

  p {
    margin-bottom: 14px;

    & > *:last-child {
      margin-left: 4px;
    }
  }

  a {
    text-decoration: underline;
  }
`;

export const ActivateLink = styled(BaseLink)`
  font-weight: 600;
  line-height: 1.43;
`;
